import { render, staticRenderFns } from "./agentEntrustTab.vue?vue&type=template&id=5b400422"
import script from "./agentEntrustTab.vue?vue&type=script&lang=js"
export * from "./agentEntrustTab.vue?vue&type=script&lang=js"
import style0 from "./agentEntrustTab.vue?vue&type=style&index=0&id=5b400422&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports